const mEditionBillingAcademyPaymentsSubscribedPlan = {
  mEditionBillingAcademyPaymentsSubscribedPlan: {
    infoRigth: {
      subscription: {
        payNext: 'El próximo pago será el'
      }
    }
  }
}

export default mEditionBillingAcademyPaymentsSubscribedPlan
